import { ComponentFactoryResolver, ComponentRef, Injectable, ViewContainerRef } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { AchievementDetailDTO } from "src/app/data/schema/Gamification/AchievementDetail/AchievementDetailDTO";
import { AchievementPlayerDialogComponent } from "./achievement-player-dialog.component";

@Injectable({
    providedIn: "root"
})
export class AchievementPlayerDialogService {
    private componentSubscriber!: Subject<string>;
    private componentRef!: ComponentRef<AchievementPlayerDialogComponent>;

    entry!: ViewContainerRef;
    openedId: string;
    constructor(private resolver: ComponentFactoryResolver) {}

    openDialog(detail: AchievementDetailDTO): Observable<string> {
        const factory = this.resolver.resolveComponentFactory(AchievementPlayerDialogComponent);
        this.componentRef = this.entry.createComponent(factory);
        this.componentRef.instance.detail = detail;
        this.componentRef.instance.closeMeEvent.subscribe(() => this.closeDialog());
        this.componentSubscriber = new Subject<string>();
        this.openedId = detail.id;

        return this.componentSubscriber.asObservable();
    }

    closeDialog(): void {
        this.componentSubscriber.next();
        this.componentRef.destroy();
    }

    setEntry(entry: ViewContainerRef): void {
        this.entry = entry;
    }
}
